module.exports = __webpack_public_path__ + "static/media/2122-service-2-1-min.4a272f65.jpg";